<div class="ai-summary-content">
  <div class="ai-summary-header">
    <h2>{{ summaryTitle }}</h2>
    <div class="ai-summary-badge">
      <mat-icon svgIcon="sparkles"></mat-icon>
      <span>AI generated</span>
    </div>
  </div>
  <div *ngIf="summary | async as summary; else loading">
    <!--Render as segments-->
    <p *ngIf="getSegments(summary) as segments">
      <ng-container *ngFor="let segment of segments">
        <span
          class="link-style"
          *ngIf="$any(segment).type === 'term'"
          (click)="onSegmentClicked(segment)"
          >{{ $any(segment).text }}</span
        >
        <span *ngIf="$any(segment).type !== 'term'">{{ $any(segment).text }}</span>
      </ng-container>
    </p>
    <!--Render as regular text-->
    <p *ngIf="getSummaryText(summary) as summaryText">{{ summaryText }}</p>
  </div>
</div>

<ng-template #loading>
  <div class="ai-summary-loading">
    <div class="loading-spinner"></div>
    <p>Generating summary...</p>
  </div>
</ng-template>
